




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Clickoutside from './clickoutside'
@Component({
  directives: {
    Clickoutside,
  },
})
export default class MyTextArea extends Vue {
  @Prop(String) value: string
  active: boolean = false
  currentValue: string = null
  mounted() {
    console.log(!this.currentValue)
  }
  doCloseActive() {
    this.active = false
  }

  handleClear() {
    this.currentValue = null
  }
  // TODO 与change区别
  handleInput() {
    this.$emit('input', this.currentValue)
  }
  @Watch('value')
  onValueChanged(newVal) {
    this.currentValue = newVal
  }
}
